import { useAppVersion } from '@/composables/useAppVersion'

// 全局版本信息访问器
declare global {
  interface Window {
    __APP_VERSION_INFO__: any
  }
}

/**
 * 初始化全局版本信息
 * 在开发者工具中可以通过 window.__APP_VERSION_INFO__ 访问
 */
export function initGlobalVersionInfo() {
  const { getVersionInfo, logVersionInfo, getVersionDetails } = useAppVersion()

  // 在全局暴露版本信息
  window.__APP_VERSION_INFO__ = {
    // 版本信息对象
    info: getVersionInfo(),

    // 打印版本信息到控制台
    log: logVersionInfo,

    // 获取版本详情文本
    details: getVersionDetails,

    // 显示版本信息（美化输出）
    show() {
      const info = getVersionInfo()
      console.log(
        `%c版本: ${info.versionSummary}`,
        'color: #00ff00; font-weight: bold; font-size: 16px;'
      )
      console.log(
        `%c构建信息: ${info.buildTimeFormatted} (${info.buildMode})`,
        'color: #00bfff; font-weight: bold;'
      )
      console.log(`%c分支: ${info.gitBranch}`, 'color: #ffa500; font-weight: bold;')
    }
  }

  // 在控制台输出欢迎信息
  const info = getVersionInfo()
  console.log(
    `%c
    ██╗   ██╗██╗██████╗  ██████╗
    ██║   ██║██║██╔══██╗██╔════╝
    ██║   ██║██║██████╔╝██║  ███╗
    ╚██╗ ██╔╝██║██╔═══╝ ██║   ██║
     ╚████╔╝ ██║██║     ╚██████╔╝
      ╚═══╝  ╚═╝╚═╝      ╚═════╝

    版本: ${info.versionSummary}
    构建: ${info.buildTimeFormatted}
    分支: ${info.gitBranch}

    提示: 使用 window.__APP_VERSION_INFO__.show() 查看完整版本信息
    `,
    'color: #00ff88; font-family: monospace;'
  )
}
